import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useDynamicLogo } from "@/lib/useLogo";

export default function SiteLayout({ children, transparentNav = false, noPadding = false }) {
  const [maintenance, setMaintenance] = useState({ on: false, msg: "" });
  const [siteName, setSiteName] = useState("Berdhill Rooms");
  const [faviconUrl, setFaviconUrl] = useState("");
  const { user } = useAuth() || {};
  const logoUrl = useDynamicLogo();

  useEffect(() => {
    api.get("/settings").then((r) => {
      const m = r.data?.maintenance_mode?.value === "true";
      setMaintenance({ on: m, msg: r.data?.maintenance_message?.value || "We're making some improvements. Please check back shortly." });
      const sn = r.data?.site_name?.value;
      if (sn) {
        setSiteName(sn);
        document.title = sn;
      }
      const fav = r.data?.favicon_url?.value;
      if (fav) {
        setFaviconUrl(fav);
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
        link.href = fav;
      }
    }).catch(() => {});
  }, []);

  // Allow staff/admin to bypass maintenance
  const isStaff = user && (user.role === "admin" || user.role === "staff");

  if (maintenance.on && !isStaff) {
    return (
      <div data-testid="maintenance-screen" className="min-h-screen flex items-center justify-center bg-brand-bg px-4 text-center">
        <div className="max-w-md">
          <img src={logoUrl} alt={siteName} className="h-20 mx-auto mb-8" />
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-100 text-amber-700 mb-6"><Wrench size={22} /></div>
          <h1 className="font-display text-4xl">We'll be back shortly</h1>
          <p className="mt-4 text-brand-muted">{maintenance.msg}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-brand-bg">
      <Navbar transparent={transparentNav} />
      <main className={`flex-1 ${noPadding ? "" : "pt-20"}`}>{children}</main>
      <Footer />
    </div>
  );
}
